export default "/assets/website/images/store-5.jpeg?636ca627cf40ea515f513ed9415ecbed";